const ErrorContainer = ({ text }) => {
    return (
        <section className="tw-w-full tw-min-h-[45px] tw-bg-gray-50 tw-p-4 tw-flex tw-justify-center tw-items-center tw-my-5 tw-text-center">
            <span className="tw-font-normal tw-text-lg tw-text-gray-500">{text}</span>
        </section>
    )
}

export default ErrorContainer;